module.exports = __webpack_public_path__ + "static/media/session8.709a51c6.svg";